import React from 'react';
import { Link } from 'react-router-dom';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ConstructionIcon from '@mui/icons-material/Construction';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ErrorPageLayout from './ErrorPageLayout';

const NotImplemented: React.FC = () => {
  return (
    <ErrorPageLayout
      icon={<ConstructionIcon sx={{ fontSize: 44 }} />}
      color="warning"
      code="501"
      title="このページは準備中です"
    >
      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8 }}>
        このページは現在開発中のため、まだご利用いただけません。
      </Typography>
      <Stack direction="row" spacing={1.5} sx={{ mt: 1 }}>
        <Button
          variant="contained"
          component={Link}
          to="/"
          startIcon={<ArrowBackIcon />}
          sx={{
            px: 3,
            py: 1,
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: 'none',
            '&:hover': { boxShadow: 'none' },
          }}
        >
          TOPへ戻る
        </Button>
      </Stack>
    </ErrorPageLayout>
  );
};

export default NotImplemented;
